<div *ngIf="dataload">

  <div class="pop-bg">
  </div>
  <div class="pop-position">
    <div class="modal readview-count-popup in" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel"
      style="display: block;">
      <div class="modal-dialog modal-md white width-modal" role="document">
        <div class="modal-content white mb-0 pb-0 border-radius-25" style="width:100%">
          <div class="row col-md-12 p-0 grey header-popup-box">
            <span class="col-md-10 col-sm-10 p-0">
              <div class="heading-panel sT-hight pl-10">
                <span class="text-sm text-ellipsis heading-txt flex ml-10">Instruction</span>
              </div>
            </span>
            <span class="pull-right text-right col-md-2 col-sm-2 pv-10 cursor" (click)="toggleModel()">
              <i class="fa fa-times" aria-hidden="true"></i>
            </span>
          </div>
          <!-- <div class="col-md-12 col-sm-12 col-xs-12 p-0" style="padding: 1rem">
            <label style="float: right;"
              class="export-btn label blue btn-text label-info square-btn cursor mt-0 pull-right mr-5">
              <i class="fa fa-file-excel-o mr-5" aria-hidden="true"></i>Export To Excel</label>
          </div> -->
          <div class="col-md-12 p-0 d-flex mt-10">
            <div class="col-md-6">
              <label class="custom-control client-conf" for="">Scenario
                <span class="required-asterisk">*</span>
              </label>
              <textarea id="textareaScenario" [disabled]="disabledInstruction" maxlength="1000" rows="6" name="InstructionScenario"
                class="form-control" [(ngModel)]="Instructions_Scenario"
                placeholder="Enter Scenario for instruction here"></textarea>
                <label [ngClass]="{'blink_me': Instructions_Scenario.length == 1000 }" class="t-bold" for="">{{Instructions_Scenario.length}}|1000</label>
            </div>
            <div class="col-md-6">
              <label class="custom-control client-conf" for="">Action
                <span class="required-asterisk">*</span>
              </label>
              <textarea id="textareaAction" [disabled]="disabledInstruction" maxlength="1000" rows="6" name="InstructionAction"
                class="form-control" [(ngModel)]="Instructions_Action"
                placeholder="Enter Action for instruction here"></textarea>
                <label [ngClass]="{'blink_me': Instructions_Action.length == 1000 }" class="t-bold" for="">{{Instructions_Action.length}}|1000</label>
            </div>
          </div>
          <div class="col-md-12 p-0 mt-20 mb-10" style="margin-left: -12px;">
            <button *ngIf="!disabledInstruction" [disabled]="!disabledInstruction && (Instructions_Scenario.length == 0 || Instructions_Action.length == 0)" class="btn blue square-btn blue-hover btn-txt float-right btn-default"
              id="toast-btn" (click)="instructionData()">Save</button>
          </div>
        </div>
      </div>
    </div>
  </div>

</div>
